/* __next_internal_client_entry_do_not_use__ RenderMarketingBuilderPageRoute auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createElement as _createElement } from "react";
import { BuilderMarketingLandingPage } from "@faire/retailer-visitor-shared/views/builder/BuilderMarketingLandingPage";
import { Route } from "@faire/web-api--source/Route";
import { props as affiliatesRouteProps } from "@faire/web-api--source/routes/affiliates";
import { props as atlRouteProps } from "@faire/web-api--source/routes/atl";
import { props as atlantamarketRouteProps } from "@faire/web-api--source/routes/atlanta-market";
import { props as autumnFairRouteProps } from "@faire/web-api--source/routes/autumn-fair";
import { props as builderRouteProps } from "@faire/web-api--source/routes/builder";
import { props as builderTestingRouteProps } from "@faire/web-api--source/routes/builder-testing";
import { props as directMail1RouteProps } from "@faire/web-api--source/routes/direct-mail1";
import { props as expoRouteProps } from "@faire/web-api--source/routes/expo";
import { props as faireForecast2025RouteProps } from "@faire/web-api--source/routes/faire-forecast-2025";
import { props as fancyFoodRouteProps } from "@faire/web-api--source/routes/fancy-food";
import { props as forecastRouteProps } from "@faire/web-api--source/routes/forecast";
import { props as grandPrixRouteProps } from "@faire/web-api--source/routes/grand-prix";
import { props as harrogateRouteProps } from "@faire/web-api--source/routes/harrogate";
import { props as magiclvRouteProps } from "@faire/web-api--source/routes/magiclv";
import { props as newyear25RouteProps } from "@faire/web-api--source/routes/NEWYEAR25";
import { props as pglRouteProps } from "@faire/web-api--source/routes/pgl";
import { props as springFairRouteProps } from "@faire/web-api--source/routes/spring-fair";
import { props as standAgainstBlandRouteProps } from "@faire/web-api--source/routes/stand-against-bland";
import { props as trendsetRouteProps } from "@faire/web-api--source/routes/trendset";
import React from "react";
export var RenderMarketingBuilderPageRoute = function() {
    var builderLPRoutes = [
        builderRouteProps,
        pglRouteProps,
        affiliatesRouteProps,
        fancyFoodRouteProps,
        atlantamarketRouteProps,
        magiclvRouteProps,
        standAgainstBlandRouteProps,
        harrogateRouteProps,
        autumnFairRouteProps,
        grandPrixRouteProps,
        directMail1RouteProps,
        builderTestingRouteProps,
        atlRouteProps,
        expoRouteProps,
        springFairRouteProps,
        trendsetRouteProps,
        faireForecast2025RouteProps,
        newyear25RouteProps,
        forecastRouteProps
    ];
    return builderLPRoutes.map(function(route) {
        return /*#__PURE__*/ _createElement(Route, _object_spread_props(_object_spread({}, route), {
            component: BuilderMarketingLandingPage,
            exact: true,
            key: route.path
        }));
    });
};
